
import { Component, ModelSync, Prop, Vue, Watch } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import {Firmware} from"@/api/dtos/Firmware.schema";
import EditFrame from "../EditFrame.vue";
import moment from "moment";
import api from "@/api";
import CancelButton from '../buttons/CancelButton.vue'
import AddButton from '../buttons/AddButton.vue'
import DangerDialog from '../dialogs/DangerDialog.vue'
import { getDeviceTypes } from "@/api/stations";
import { AvailableDevices, Device,Card } from "@/api/dtos/AvailableDevices.schema.d";
import {
  formatBookingWallTimeInGermanTime,
  formatBookingWallTimeInZone,
  getBookingTimeZone,
  isGermanBookingTimeZone,
} from "@/utils/bookingDateFormatter";


@Component({
  components: {
    ContainerFrame,
    EditFrame,
    CancelButton,
    AddButton
  },
})
export default class CreateBookingDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ required: true })
  box!: Device;

  @Prop({ required: true })
  price!: string;

  @Prop({ default: () => [] })
  cardOccupations!: any[]; 
  
  // @Prop()
  // cards!: Card[];

  @Prop()
  timeRange!: string[];

  @Prop()
  bookingTimeZone!: string | null;
  
  @Prop()
  email!: string[];

  localEmail: string = "";
  emailValidationErrors: string[] = [];

  detailsOpen = false;

  get cardSelectItems() {
    return (this.availableCards ?? []).map((c: Card) => ({
      text: `${c.name} (${c.uid})`,
      value: c,
      count: this.occByUid[c.uid]?.count ?? 0,
    }));
  }

  get availableCards(): Card[] {
    return ((this.box as any)?.cards ?? []) as Card[];
  }

  get assignedType(): string {
    return this.box?.typeSettings?.assignedType ?? "-";
  }

  get assignedProperties(): string[] {
    return this.box?.typeSettings?.assignedProperties ?? [];
  }

  get selectedCardUid(): string | null {
    return (this.selectedCard as any)?.uid ?? null;
  }

  get selectedCardOcc(): any | null {
    const uid = this.selectedCardUid;
    if (!uid) return null;
    return this.occByUid[uid] ?? null;
  }

  get selectedCardOccCount(): number {
    return this.selectedCardOcc?.count ?? 0;
  }

  get effectiveBookingTimeZone(): string {
    return getBookingTimeZone(
      this.bookingTimeZone ?? (this.box as any)?.bookingTimeZone
    );
  }

  get timeBasisLabel(): string {
    return isGermanBookingTimeZone(this.effectiveBookingTimeZone)
      ? "Ortszeit der Station"
      : `Gerätezeit ${this.effectiveBookingTimeZone}`;
  }

  get showGermanTimeComparison(): boolean {
    return !isGermanBookingTimeZone(this.effectiveBookingTimeZone);
  }

  formatDateTime(iso: string): string {
    return `${formatBookingWallTimeInZone(
      iso,
      this.effectiveBookingTimeZone
    )} Uhr`;
  }

  get occByUid(): Record<string, any> {
    const map: Record<string, any> = {};
    (this.cardOccupations ?? []).forEach((c: any) => {
      map[c.uid] = c;
    });
    return map;
  }

  getSelectedCardOccCount(): number {
    const uid = (this.selectedCard as any)?.value?.uid;
    return uid ? (this.occByUid[uid]?.count ?? 0) : 0;
  }


  selectedCard: Card[] = [];

  hardwareTypes: string[] = ["BIKE_PARK_BOX_CONTROLLER"];

  save () :void {
    this.$emit('save',{device:this.box, email:this.localEmail,card: this.selectedCard})
    this.show = false;
  }

  @Watch("show")
  onShowChanged(val: boolean) {
    if (val) {
      this.detailsOpen = false;
      this.selectedCard = [] as any;
      this.localEmail = (this.box as any)?.defaultBookingEmail ?? "";
      this.emailValidationErrors = [];
    }
  }

  onCancel () {
    this.$emit('cancel')
  }

  async mounted(){

  }

  async validateEmail(): Promise<void> {
    if (!this.localEmail) return;
    const isValidEmailErrorMessage = this.$validation.vuetify.single({
      presence: true,
      email: true,
    })(this.localEmail);
    if (typeof isValidEmailErrorMessage === "string") {
      this.emailValidationErrors = [isValidEmailErrorMessage];
      return;
    }
    try {
      const userExists = await api.UsersApi.userExists(this.localEmail);
      this.emailValidationErrors = userExists ? [] : ["Nutzer existiert nicht"];
    } catch (e) {
      this.emailValidationErrors = ["Nutzer existiert nicht"];
    }
  }

  formatTimestamp(ts: string): string {
    return `${formatBookingWallTimeInZone(
      ts,
      this.effectiveBookingTimeZone
    )} Uhr`;
  }

  formatGermanTimestamp(ts: string): string {
    return `${formatBookingWallTimeInGermanTime(
      ts,
      this.effectiveBookingTimeZone
    )} Uhr`;
  }

  moment = moment;
}
